import React, { ChangeEvent } from 'react';

// Lib
import { convertDataPrices } from 'lib/helpers';
import { useAppDispatch } from 'lib/hooks/useDispatch';

// Components
import DataRowItem from './DataRowItem';
import DataCartItem from './DataCartItem';

// Actions
import * as actionsCreator from 'pages/Pfizer/reducer';

// Type
import { Supplier } from 'pages/MoleculeProduct/reducer';
type TMap = {
	[index: string]: string | number | boolean
};
type TPrice = {
	mg?: number,
	priceEur?: number,
	priceUsd?: number,
	available?: boolean,
};

// Interface
interface ICartChemicalProbes {
	id?: string;
	px?: number;
	doi?: string;
	cas?: string;
	target?: string;
	action?: string;
	name?: string;
	isPOA: boolean;
	title?: string;
	dbId?: string;
	prices: {
		supplier?: string;
		prices?: TPrice[];
	}[],
	descriptor?: any;
	onStock?: boolean;
	cxSmiles?: string;
	quantity?: number;
	iupacName?: string;
	countPrice: number;
	selected?: boolean;
	type: string;
	supIds?: Supplier[];
	currentPrice?: any;
	numeration?: string;
	description?: string;
	currentTypePrice: string;

	offAllFunctions: boolean;

	classNameWrapper?: string;
}

export const CartPfizerContainer: React.FC<ICartChemicalProbes> = (props) => {
	const {
		id,
		cas,
		name,
		isPOA,
		prices,
		quantity,
		onStock,
		numeration,
		selected,
		currentPrice,
		currentTypePrice,

		type,

		offAllFunctions = false,
		classNameWrapper,
	} = props;
	const dispatch = useAppDispatch();

	const handleChangePrices = (data: TMap) => {
		if(offAllFunctions) return;
		dispatch(actionsCreator.changePriceItem({
			id: id,
			data: data
		}));
	};

	const handleClickPlus = (number: number) => {
		if(offAllFunctions) return;

		dispatch(actionsCreator.changeQuantity({
			id: id,
			quantity: number
		}));
	};

	const handleClickMinus = (number: number) => {
		if(offAllFunctions) return;

		dispatch(actionsCreator.changeQuantity({
			id: id,
			quantity: number
		}));
	};

	const handleChangeCheckbox = (id: string) => (e: ChangeEvent<HTMLInputElement>) => {
		if(offAllFunctions) return;

		dispatch(actionsCreator.changeCheckboxItem({
			id: id,
			selected: e.target.checked
		}));
	};

	const handleChangeTypePrice = (type: string) => {
		if(offAllFunctions) return;

		dispatch(actionsCreator.changeCurrentPriceType({
			id: id,
			type: type
		}));
		dispatch(actionsCreator.changePriceItem({
			id: id,
			data: {}
		}));
	};

	const optionsTypePrices = prices?.length ? prices.map((item) => ({
		label: item.supplier || '',
		value: item.supplier || ''
	})) : [];

	const options = prices?.length
		? prices?.find((item) => item.supplier === currentTypePrice)
		: {};
	const convertedOptions = convertDataPrices(options?.prices ? options?.prices : []);

	const titlePOA = isPOA ? "Price on asking" : "";
	const to = `${window.location.origin}/molecule-product/${id}`;

	const COMPONENT_MAP: { [index: string]: React.ComponentType<any> } = {
		'row': DataRowItem,
		'cart': DataCartItem,
	};

	const Component = COMPONENT_MAP[type];

	return <Component
		id={id}
		to={to}
		cas={cas}
		name={name}
		isPOA={isPOA}
		onStock={onStock}
		selected={selected}
		titlePOA={titlePOA}
		quantity={quantity}
		numeration={numeration}
		currentPrice={currentPrice}
		handleClickPlus={handleClickPlus}
		classNameWrapper={classNameWrapper}
		handleClickMinus={handleClickMinus}
		convertedOptions={convertedOptions}
		currentTypePrice={currentTypePrice}
		optionsTypePrices={optionsTypePrices}
		handleChangePrices={handleChangePrices}
		handleChangeCheckbox={handleChangeCheckbox}
		handleChangeTypePrice={handleChangeTypePrice}
	/>;
};

export default CartPfizerContainer;